import React from "react"
import textData from "../../data/textData"
import QuestionTemplate from "../templates/question-template"
import Layout from "../layout"

const Question = props => {
  const selectChoice = element => {
    props.toAnswer(element.correct)
  }
  const randomNo = 1 + Math.floor(Math.random() * 4)
  const Props = {
    index: props.index,
    resultList: props.resultList,
    gImageNameSP: `qUme0${randomNo}SP`,
    gImageNamePC: `qUme0${randomNo}PC`,
    qImagename: "qImage" + textData[props.index].no,
    data: textData[props.index],
    choiceFunc: selectChoice,
  }

  return (
    <Layout>
      <QuestionTemplate {...Props} />
    </Layout>
  )
}

export default Question
